/**
 * Thrown when a manifest is formatted incorrectly
 */
export default class InvalidManifestError extends Error {

    /**
     * Creates a new instance of InvalidManifestError
     * @param {string} nodeType The type of the node that was invalid
     * @param {string} nodeId The id of the node that was invalid
     * @param {string} message An option message.
     */
    constructor(nodeType, nodeId, message) {
        super(`The ${nodeType} with id of ${nodeId} is invalid. Error Message: ${message}`);

        this.nodeType = nodeType;
        this.nodeId = nodeId;
        this.message = message;
    }
}



// WEBPACK FOOTER //
// ./source/framework/errors/InvalidManifestError.js